import { DynamicQueryEvent, DynamicQueryEventTypes } from '../dynamicquery/dynamic-query-events.factory';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Visit } from 'common/xislivechat/models/visit';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';

@Injectable({
  providedIn: 'root'
})
export class VisitsService {
  constructor(private _dynamicQuery: DynamicQueryAdapterService,
              private _dynamicQueryDecorator: DynamicQueryDecoratorService) {
  }

  observeVisitInfoByVisitId(visitId, visitorId) {
    const visitObservable = this._dynamicQuery.getQuery('visitInfoByVisitID', { VisitID: visitId, VisitorID: visitorId });
    return this._dynamicQueryDecorator.create(visitObservable, Visit.wrap).pipe(
      filter((dynamicQueryEvent: DynamicQueryEvent) => {
        return dynamicQueryEvent.event !== DynamicQueryEventTypes.DONE;
      }),
      distinctUntilChanged((a: DynamicQueryEvent, b: DynamicQueryEvent) => {
        return a.data && b.data && a.data.CurrentUrl === b.data.CurrentUrl;
      })
    );
  }

  createObservableByVisitorId(visitId, visitorId, created) {
    if (!visitorId) {
      throw new Error('Missing visitorId!');
    }
    if (!visitId) {
      throw new Error('Missing visitId!');
    }
    if (!created) {
      throw new Error('Missing created date!');
    }

    const visitObservable = this._dynamicQuery.getQuery('pageViewsByVisitorIDVisitIDCreated', { VisitID: visitId, VisitorID: visitorId, Created: created });
    return this._dynamicQueryDecorator.create(visitObservable, Visit.wrap);
  }
}
